export function createActions(dispatch) {
  return {
    tokenStatus: (payload) =>
      dispatch({type: ACTION_TYPES.TOKEN_STATUS, payload}),
    setCustomerId: (payload) =>
      dispatch({type: ACTION_TYPES.SET_CUSTOMER_ID, payload}),
    enableSlotRebooking: () =>
      dispatch({type: ACTION_TYPES.ENABLE_SLOT_REBOOKING}),
    reset: () => dispatch({type: "reset"}),
  };
}

export const ACTION_TYPES = {
  SET_CUSTOMER_ID: "SET_CUSTOMER_ID",
  ENABLE_SLOT_REBOOKING: "ENABLE_SLOT_REBOOKING",
  TOKEN_STATUS: "TOKEN_STATUS",
};
